import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { AuthClient, MOCK_DEV_USER } from './AuthClient';
const AuthContext = createContext({ user: null, loading: false, logout: () => { } });
function initialAuthState() {
    const token = AuthClient.getAccessToken();
    if (!token) {
        return { user: null, loading: false };
    }
    if (AuthClient.isMockMode()) {
        return { user: MOCK_DEV_USER, loading: false };
    }
    return { user: null, loading: true };
}
export function useAuth() {
    return useContext(AuthContext);
}
export function AuthProvider({ children }) {
    const init = initialAuthState();
    const [user, setUser] = useState(init.user);
    const [loading, setLoading] = useState(init.loading);
    useEffect(() => {
        const token = AuthClient.getAccessToken();
        if (!token || AuthClient.isMockMode()) {
            return;
        }
        let cancelled = false;
        async function loadUser() {
            try {
                // Wait out a near-expiry token's refresh first, so this mount-time call doesn't
                // lose the race against the background refresh timer and get 401'd on a stale
                // token. A failed refresh is ignored here — the /v1/auth/me call below still
                // fires, and its 401 interceptor is the source of truth for signing the user out.
                try {
                    await AuthClient.ensureFreshToken();
                }
                catch {
                    // ignored — see comment above
                }
                const res = await apiClient.get('/v1/auth/me');
                if (!cancelled)
                    setUser(res.data);
            }
            catch {
                if (!cancelled)
                    setUser(null);
            }
            finally {
                if (!cancelled)
                    setLoading(false);
            }
        }
        void loadUser();
        return () => {
            cancelled = true;
        };
    }, []);
    return (_jsx(AuthContext.Provider, { value: { user, loading, logout: AuthClient.logout }, children: children }));
}
